import { Directive, ViewChildren } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { EaEarningFormComponent } from '../ea-earning-form/ea-earning-form.component';

@Directive()
export abstract class PrProfessionFormBuilder extends PrFormAbstract {
  @ViewChildren(EaEarningFormComponent) nestedForms;

  generateEarning(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        startDate: [entity ? entity.startDate : null, Validators.required],
        endDate: [entity ? entity.endDate : null],
        connaissance: [
          entity && entity.connaissance ? entity.connaissance : 'netMensuel',
          Validators.required,
        ],
        amount: [entity ? entity.amount : null, Validators.required],
        fraisReel: [entity ? entity.fraisReel : null],
      },
      options,
    );
  }

  generate(entity: any) {
    let options: AbstractControlOptions = {};

    let earnings: UntypedFormGroup[] = [];
    if (entity.earnings)
      for (let earning of entity.earnings)
        earnings.push(this.generateEarning(earning));

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        accountId: [entity ? entity.accountId : null, Validators.required],
        userId: [entity ? entity.userId : null, Validators.required],
        type: [entity ? entity.type : null, Validators.required],
        label: [entity ? entity.label : null, Validators.required],
        companyName: [entity ? entity.companyName : null],
        situation: [entity ? entity.situation : null],
        activitySector: [entity ? entity.activitySector : null],
        groupe: [entity ? entity.groupe : null],
        categorie: [entity ? entity.categorie : null],
        estimatedEvolution: [entity ? entity.estimatedEvolution : null],
        workInPublic: [entity ? entity.workInPublic : false],

        earnings: this.formBuilder.array(earnings, Validators.required),
      },
      options,
    );
  }

  extractEarning(form: UntypedFormGroup) {
    let dto: any = {
      id: this.emptyIsNull(form.value.id),
      startDate: this.emptyIsNull(form.value.startDate),
      endDate: this.emptyIsNull(form.value.endDate),
      fraisReel: this.emptyIsNull(form.value.fraisReel),
    };
    let amount = parseFloat(form.value.amount);
    switch (form.value.connaissance) {
      case 'netMensuel':
        dto.amount = amount;
        break;
      case 'netAnnuel':
        dto.amount = amount / 12;
        break;
      case 'brutMensuel':
        dto.amount = amount * 0.78;
        break;
      case 'brutAnnuel':
        dto.amount = (amount * 0.78) / 12;
        break;
    }
    return dto;
  }

  extract() {
    let earnings: UntypedFormGroup[] = [];

    for (let earningForm of this.nestedForms) {
      let earning = earningForm.extract();
      earning = {
        ...earning,
        ...{
          frequency: 'MENS',
          label: this.emptyIsNull(this.form.value.label),
          type: this.form.value.type,
          professionId: this.form.value.id,
          userId: this.form.value.userId,
        },
      };
      earnings.push(earning);
    }

    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      accountId: this.emptyIsNull(this.form.value.accountId),
      type: this.emptyIsNull(this.form.value.type),
      categorie: this.emptyIsNull(this.form.value.categorie),
      companyName: this.emptyIsNull(this.form.value.companyName),
      estimatedEvolution: this.emptyIsNull(this.form.value.estimatedEvolution),
      groupe: this.emptyIsNull(this.form.value.groupe),
      label: this.emptyIsNull(this.form.value.label),
      situation: this.emptyIsNull(this.form.value.situation),
      activitySector: this.emptyIsNull(this.form.value.activitySector),
      workInPublic: this.emptyIsNull(this.form.value.workInPublic),
      userId: this.form.value.userId,
      earnings: earnings,
    };
    return dto;
  }

  get earnings() {
    return this.form.get('earnings') as UntypedFormArray;
  }

  earning(index: number) {
    return this.earnings.at(index) as UntypedFormGroup;
  }

  addEarning() {
    let earning = {};
    if (!this.entity.earnings) this.entity.earnings = [];
    this.entity.earnings.push(earning);
    this.earnings.push(this.generateEarning(earning));
  }
}
